import React from 'react';
import styles from './MenuSidebar.module.css';

const MenuSidebar = ({ activeTab, onTabChange }) => {
    const menuItems = [
        { id: 'details', label: 'Details' },
        { id: 'services', label: 'Services' },
        { id: 'workHours', label: 'Work Hours' },
        { id: 'attendance', label: 'Attendance' },
        { id: 'break', label: 'Break' }
    ];

    return (
        <div className={styles.menuSidebar}>
            <ul className={styles.menuList}>
                {menuItems.map((item) => (
                    <li 
                        key={item.id}
                        className={`${styles.menuItem} ${activeTab === item.id ? styles.active : ''}`}
                        onClick={() => onTabChange(item.id)}
                    >
                        {item.label}
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default MenuSidebar;

